export default {
  mutateAddedSubject(state, data) {
    state.addedSubject = data;
  },
};
